angular.module('tf.controllers')
    .controller('CloudEditorController', function ($scope, HttpService, $timeout, $stateParams, HeaderService) {
            console.log($stateParams);
            $scope.path = $stateParams.path;
            HeaderService.setName("Cloud Templates");
            // const root = document.getElementById('cloud-editor');
            // const builder = document.createElement('te-designer');
            // builder.template =  $stateParams.path;
            // root.appendChild(builder);
            window.TE.mount('#cloud-editor',{apiEndpoint:window.location.origin + '/api'});
        });
